<main class="bg-white position-relative">

  <div class="contact-map">
    <div id="map"></div>
  </div>
  <div class="contact-form container">
    <div class="contact-body">
      <div class="contact-left-sec">
        <div class="contact-information">
          <h2>Contact</h2>
          <div class="contact-info">
            <i class="flaticon-email"></i>
            <a href="mailto:Deercreative@gmail.com">Deercreative@gmail.com</a>
          </div>
          <div class="contact-info">
            <i class="flaticon-phone"></i>
            <a href="tel:+8748864174">(+87) 4886-4174</a>
          </div>
          <div class="contact-info">
            <i class="flaticon-place"></i>
            <p>1429 Netus Rd, 48247 Fusce Rd, NY</p>
          </div>
          <div class="contact-social">
            <a href="javascript:void(0);" target="_blank"><i class="fa fa-facebook"></i></a>
            <a href="javascript:void(0);" target="_blank"><i class="fa fa-twitter"></i></a>
            <a href="javascript:void(0);" target="_blank"><i class="fa fa-google-plus"></i></a>
            <a href="javascript:void(0);" target="_blank"><i class="fa fa-instagram"></i></a>
            <a href="javascript:void(0);" target="_blank"><i class="fa fa-youtube-play"></i></a>
          </div>
          <div class="mail-icon">
            <i aria-hidden="true" class="fa fa-envelope"></i>
          </div>
        </div>
      </div>
      <div class="contact-right-sec">
        <h2>Get In Touch</h2>
        <form action='#' method='post'>
          <div class="row">
            <div class="col-sm-6">
                                <span class="input input--yoshiko">
                                    <input class="input__field input__field--yoshiko" id="input-10" name="fname"
                                           required
                                           type="text"/>
                                    <label class="input__label input__label--yoshiko" for="input-10"> <span
                                      class="input__label-content input__label-content--yoshiko"
                                      data-content="First Name">Your Name</span> </label>
                                </span>
            </div>
            <div class=" col-sm-6">
                                <span class="input input--yoshiko">
                                    <input class="input__field input__field--yoshiko" id="input-11" name="email"
                                           required
                                           type="email"/>
                                    <label class="input__label input__label--yoshiko" for="input-11"> <span
                                      class="input__label-content input__label-content--yoshiko"
                                      data-content="Email Address">Email Address</span> </label>
                                </span>
            </div>
          </div>
          <div class="row">
            <div class=" col-sm-6">
                                <span class="input input--yoshiko">
                                    <input class="input__field input__field--yoshiko" id="input-12" name="pnumber"
                                           required type="text"/>
                                    <label class="input__label input__label--yoshiko" for="input-12"> <span
                                      class="input__label-content input__label-content--yoshiko"
                                      data-content="Phone Number">Your Phone Number</span> </label>
                                </span>
            </div>
            <div class=" col-sm-6">
                <span class="input input--yoshiko">
                    <input class="input__field input__field--yoshiko" id="input-13" name="fname" required
                           type="text"/>
                    <label class="input__label input__label--yoshiko" for="input-13"> <span
                      class="input__label-content input__label-content--yoshiko"
                      data-content="First Name">Company</span> </label>
                </span>
            </div>
          </div>
          <div class="row">
            <div class=" col-sm-12">
                <span class="input input--yoshiko">
                    <textarea class="input__field input__field--yoshiko" id="input-14"
                              name="message"></textarea>
                    <label class="input__label input__label--yoshiko" for="input-14"> <span
                      class="input__label-content input__label-content--yoshiko"
                      data-content="Message">Message</span> </label>
                </span>
            </div>
          </div>
          <div class="submit-button">
            <input class="def-btn lg-btn" name='btn' type='submit' value='Contact Us'/>
          </div>
        </form>
      </div>
    </div>
  </div>

</main>
